import { c as _c } from "react/compiler-runtime";
import { AboutPage } from "@catchy/ui";
import { getRegionConfig } from "../lib/regions/config.mjs";
const region = getRegionConfig("chch");
export default function About() {
  const $ = _c(1);
  const pages = region.publicPages;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AboutPage appName={region.branding.appName} regionName={region.label} agencyName={pages.agencyName} canonicalUrl={`${region.allowedOrigin}/about`} description={pages.aboutDescription} shareImage={`${region.allowedOrigin}/share/default-share-image.png`} modesLabel={pages.modesLabel} appsDescription={pages.appsDescription} googlePlayUrl={pages.googlePlayUrl} appleStoreUrl={pages.appleStoreUrl} includeWatchCredit={pages.includeWatchCredit} includeWearCredit={pages.includeWearCredit} includeSnapper={region.capabilities.snapper} dataCredits={pages.dataCredits} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}